import React, { useEffect, useRef, useState } from 'react';
import * as d3 from 'd3';
import data from './goldmedalistsinfo.json';
import './dataviz.scss';
import Tooltip from './Tooltip';
import ImageScroll from './ImagesScroll';
import gsap from 'gsap';
// import ScrollTrigger from 'gsap/ScrollTrigger';

function GenderLongevityV2() {
    const svgRef = useRef();
    const containerRef = useRef();

    const [tooltipContent, setTooltipContent] = useState(null);
    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
    const [hovered, setHovered] = useState(null);

    const [isToggled, setIsToggled] = useState(false);

    const handleToggle = () => {
        setIsToggled(!isToggled);
    };
    

    const sexcn = ['女', '男'];

    const colorLine = d3.scaleOrdinal()
        .domain(['男', '女']) 
        .range(['#1EB246', '#6434FF']); 

    const path = process.env.PUBLIC_URL;

    useEffect(() => {
        drawChart();
    
        let prevWidth = window.innerWidth;
        const handleResize = debounce(() => {
          const currentWidth = window.innerWidth;
          const widthDifference = Math.abs(currentWidth - prevWidth);
          
          if (widthDifference > 50) {
              drawChart();
              prevWidth = currentWidth;
          }
      }, 500);
    
      window.addEventListener('resize', handleResize);
    
        return () => {
            window.removeEventListener('resize', handleResize);
            // ScrollTrigger.getAll().forEach(trigger => trigger.kill());
        };
    }, [isToggled]); 

    const debounce = (func, delay) => {
        let timeout;
        return (...args) => {
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(() => {
                func(...args);
            }, delay);
        };
    };

    const drawChart = () => {
        // gsap.registerPlugin(ScrollTrigger);

        // Check if we're on a mobile device
        const isMobile = window.innerWidth <= 768;

        // const scrollTriggerInitialized = ScrollTrigger.getById('gender-long-id');

        // // If we're on mobile and the chart has already been drawn, exit early
        // if (isMobile && svgRef.current.querySelector('.longevity-circle')  ) {
        //     return;
        // }

        // const margin = { top: 20, right: 30, bottom: 40, left: 60 };
        // const width = 960 - margin.left - margin.right;
        // const height = 700 - margin.top - margin.bottom;

        // const svg = d3.select(svgRef.current)
        // .attr('width', width + margin.left + margin.right)
        // .attr('height', height + margin.top + margin.bottom)
        // .append('g')
        // .attr('transform', `translate(${margin.left},${margin.top})`);

        const container = d3.select(containerRef.current);
        const svg = d3.select(svgRef.current);
        const containerWidth = container.node().clientWidth;
        const containerHeight = container.node().clientHeight;

        // Retrieve the computed style of the SVG
        const computedStyle = window.getComputedStyle(svgRef.current);
    
        // Parse the CSS width as a float (removing 'px')
        const svgCssWidth = parseFloat(computedStyle.width);

        const margin = { top: 2, right: 0, bottom: 40, left: 50 };
        // const width = containerWidth - margin.left - margin.right;
        // const height = containerHeight - margin.top - margin.bottom;
        const width = isMobile ? svgCssWidth * 0.88 :containerWidth - margin.left - margin.right;
        const height = isMobile ? 650 : containerHeight - margin.top - margin.bottom; 

        svg
        .attr('viewBox', `0 0 ${containerWidth} ${containerHeight}`)
        .attr('preserveAspectRatio', 'xMinYMin meet')
        .attr('width', '100%')
        .attr('height', '100%');


        const svgGroup = svg
        .selectAll('g')
        .data([null])
        .join('g')
        .attr('transform', `translate(${margin.left},${margin.top})`);

        // filters
        const sportsData = data.filter(d =>
            ['举重', '乒乓球', '体操', '击剑', '射击', '田径', '羽毛球', '花样滑水', '跆拳道', '跳水'].includes(d.sportcn)
            );

        const ageData = data.filter(d => d.ageRetired !== "现役" && ['举重', '乒乓球', '体操', '击剑', '射击', '田径', '羽毛球', '花样滑水', '跆拳道', '跳水'].includes(d.sportcn));

        const medianAgeData = d3.group(ageData, d => `${d.sportcn}-${d.sexcn}`);

        const medianAges = Array.from(medianAgeData, ([key, values]) => {
            const ages = values.map(d => +d.ageRetired).sort(d3.ascending);
            const median = d3.median(ages);
            const [sportcn, sexcn] = key.split('-');
            return { sportcn, sexcn, median };
        });

        const genderGroup = d3.group(ageData, d => d.sexcn);

        // Calculate median ages for each gender
        const genderMedians = Array.from(genderGroup, ([sexcn, values]) => {
            const ages = values.map(d => +d.ageRetired).sort(d3.ascending);
            const median = d3.median(ages);
            return { sexcn, median };
        });

        // const sortedMedianAges = medianAges.sort((a, b) => {
        //     if (a.sportcn === b.sportcn) {
        //         return a.sexcn.localeCompare(b.sexcn);
        //     }
        //     return a.sportcn.localeCompare(b.sportcn);
        // })


        // const sortedMedianAges = medianAges.sort((a, b) => {
        //     if (a.sportcn === b.sportcn) {
        //         return a.sexcn === '女' ? -1 : 1; // Ensure '女' appears before '男'
        //     }
        //     return d3.ascending(a.sportcn, b.sportcn);
        // });

        const sortedMedianAges = medianAges.sort((a, b) => {
            if (a.sportcn !== b.sportcn) {
                return d3.ascending(a.sportcn, b.sportcn);
            }
            return a.sexcn === '女' ? -1 : 1;
        });

        
        // Set the scales
        const x = d3.scaleLinear()
        // .domain(ageData.map(d => d.ageRetired))
        // .domain([d3.min(ageData, d => d.ageRetired), d3.max(ageData, d => d.ageRetired)])
        .domain([15, 50])
        .range([0, width]);

        const y = d3.scaleBand()
        .domain(sportsData.map(d => d.sportcn))
        .range([0, height])
        .padding(0);

        const color = d3.scaleOrdinal()
        .domain(['男', '女']) 
        .range(['#71DF96', '#BB96FF']); 

        const colorLine = d3.scaleOrdinal()
        .domain(['男', '女']) 
        .range(['#1EB246', '#6434FF']); 
        
        const genderGroupData = Array.from(d3.group(ageData, d => d.sportcn), ([key, value]) => ({ key, values: value }));

        svgGroup.selectAll('line').remove(); 
        // grid and axes
        svgGroup.append('g')
            .selectAll('line')
            .data(sportsData)
            .enter().append('line')
            .attr('class', 'grid-lines')
            .attr('x1', 0)
            .attr('y1', d => y(d.sportcn) + y.bandwidth() / 2)
            .attr('x2', width)
            .attr('y2', d => y(d.sportcn) + y.bandwidth() / 2)
            .attr('transform', `translate(0, ${y.step() / 2})`);
        
        //toppity
        svgGroup.append('line')
            .attr('class','grid-lines')
            .attr('x1', 0)
            .attr('y1', 0)
            .attr('x2', width)
            .attr('y2', 0);

        const tickFormat = (d) => `${d}岁`;

        svgGroup.append('g')
            .attr('transform', `translate(0,${height})`)
            .call(d3.axisBottom(x).tickFormat(tickFormat))
            .attr('class', 'x-axis')
            .call(g => g.selectAll('.tick line')
                .attr('class', 'grid-lines')
                .attr('y2', -height));
        

            
        // svgGroup.append('g')
        // .attr('class', 'x-axis')
        // .attr('transform', `translate(0,${height})`)
        // .call(d3.axisBottom(x)
        // );

        // y-axsis
        svgGroup.append('g')
        .attr('class', 'y-axis longevity')
        .call(d3.axisLeft(y))
        .select('.domain').remove()
        .transition().duration(1500).delay(100)
        ;

        const jitter = 50;
        const jittery = 8;

        const spacing = 6;
        const sportAgeData = d3.group(ageData, d => d.sportcn, d => d.ageRetired);

       
        const flattenedData = ageData.map(d => {
            // Find all points at the same x position
            const samePositionData = Array.from(sportAgeData.get(d.sportcn)?.get(d.ageRetired) || []);

            // Calculate the x position with spacing
            const index = samePositionData.indexOf(d);
            const numPoints = samePositionData.length;

            return {
                ...d,
                xPosition: x(d.ageRetired) + (index - (numPoints - 1) / 2) * spacing,
            };
        });

        svgGroup.selectAll('circle').remove(); 

        const circles = svgGroup.selectAll('circle')
            .data(ageData, d => d.id);

        circles.enter().append('circle')
            .data(flattenedData)
            // .attr('cx', d => x(d.ageRetired))
            .attr('cx', d => d.xPosition)
            .attr('cy', d => {
                if (d.sexcn === '男') {
                    return y(d.sportcn) + y.bandwidth() / 2 + 10 + (Math.random() - 0.5) * jittery;
                }
                else if (d.sexcn === '女') {
                    return y(d.sportcn) + y.bandwidth() / 2 - 10 + (Math.random() - 0.5) * jittery;
                }
            })
            .attr('class', 'longevity-circle')
            .attr('r', 6)
            .style('fill', d => color(d.sexcn))
            .style('stroke', d => color(d.sexcn))
            .style('stroke-width', '1px')
            .attr('fill-opacity', 0.6)
            .on('mouseover', (event, d) => {
                setTooltipContent(
                    `<div class="tooltip__content">
                    <span class="tooltip__title">
                    <b>${d.namecn}</b> <span style=color:${color(d.sexcn)}>(${d.sexcn})</span></br>
                    <b>${d.sportcn}</b></br>
                    </div>
                    <span class="tooltip__details">
                    首金年份：${d.firstGoldYear}年 </br>
                    首金后职业生涯：${d.retirementYear - d.firstGoldYear}年 </br>
                    退休年龄：${d.ageRetired}岁 </br>
                    </span>
                    </div>`);
                setTooltipPosition({ x: event.pageX + 10, y: event.pageY - 28 });
                setHovered(event.target);
            })
            .on('mouseout', () => {
                setTooltipContent(null);
                setHovered(null);
            })
            // .merge(circles)
            .transition().duration(1500).delay(100);
            circles.exit().remove();

        svgGroup.selectAll('.medianLine').remove(); 

        svgGroup.selectAll('.medianLine')
            .data(sortedMedianAges)
            .enter().append('rect')
            .attr('class', 'medianLine')
            // .attr('x', d => x(d.median) - 1)
            .attr('x', d => {
                if (d.sexcn === '男') {
                    return (x(d.median) - 1.5) - 1.5
                } else if (d.sexcn === '女') {
                    return (x(d.median) - 1.5) + 1.5
                }
            })
            .attr('y', d => {

                if (d.sexcn === "男") {
                    return y(d.sportcn) + y.bandwidth() / 2 - y.bandwidth() / 2 + 28;
                } else if (d.sexcn === "女") {
                    return y(d.sportcn) + y.bandwidth() / 2 - y.bandwidth() / 2 + 5;
                }
            })
            // .attr('y', d => {
            //     const offset = 10;
            //     // console.log(`Median line for ${d.sportcn} ${d.sexcn}:`, d.median);
            //     if (d.sexcn === "男") {
            //         return y(d.sportcn) + y.bandwidth() / 2 + offset;
            //     } else if (d.sexcn === "女") {
            //         return y(d.sportcn) + y.bandwidth() / 2 - offset - 20;
            //     }
            // })
            .attr('width', 3)
            .attr('height', d => y.bandwidth() - 30)
            // .attr('height', 20)
            .attr('fill', d => colorLine(d.sexcn))
            .on('mouseover', (event, d) => {
                setTooltipContent(`
                    <span class="tooltip__content"><b>${d.sexcn}子${d.sportcn}</b></span>
                    <span class="tooltip__details">退役年龄中位数：${d.median}岁</span>`);
                setTooltipPosition({ x: event.pageX + 10, y: event.pageY - 28 });
                setHovered(event.target);
            })
            .on('mouseout', () => {
                setTooltipContent(null)
                setHovered(null);
            })
            .transition().duration(1500).delay(100);

        //gender medians
        svgGroup.selectAll('.genderMed')
            .data(genderMedians)
            .enter().append('line')
            .attr('class', 'genderMed')
            .attr('x1', d => x(d.median))
            .attr('x2', d => x(d.median))
            .attr('y1', height/9 * 6 - 10)
            .attr('y2', height/9 * 8 + 10)
            .attr('stroke', d => colorLine(d.sexcn))
            .attr('stroke-width', 3)
            .attr('opacity', 0)
            .on('mouseover', (event, d) => {
                setTooltipContent(`
                    <span class="tooltip__details"><span style="color:${d.sexcn === '男' ? '#1EB246' : '#6434FF'}; font-weight:bold">${d.sexcn}</span>整体退役年龄中位数：<span style="color:${d.sexcn === '男' ? '#1EB246' : '#6434FF'}; font-weight:bold">${d.median}岁</span></span>`);
                setTooltipPosition({ x: event.pageX + 10, y: event.pageY - 28 });
            })
            .on('mouseout', () => {
                setTooltipContent(null)
                setHovered(null);
            });


        svgGroup.selectAll('.genderMedText').remove(); 
        svgGroup.append('text')
            .attr('class', 'genderMedText')
            .attr('x', width / 2) 
            .attr('y', height / 1.7) 
            .attr('text-anchor', 'middle') 
            .attr('dominant-baseline', 'middle') 
            .attr('opacity', 0)
            .text('按性别划分退休年龄')
            ;


if (isToggled) {
    d3.selectAll('.longevity-circle').each(function(d) {
        const circle = d3.select(this);
        const sex = circle.datum().sexcn;
        const newCy = sex === '女' ? (height/9 * 6.6 + (Math.random() - 0.5) * jitter) :  (height/9 * 8 - 20  + (Math.random() - 0.5) * jitter);

        gsap.to(circle.node(), {
            attr: {
                cy: newCy
            }
        });
        gsap.to('.longevity .tick', {
            opacity: 0,
        });
        gsap.to('.medianLine', {
            opacity: 0
        });
        gsap.to('.genderMed', {
            opacity: 0.8,
        });
        gsap.to('.genderMedText', {
            duration:1,
            opacity:1
        })
    });
} else {
    d3.selectAll('.longevity-circle').each(function(d) {
        const circle = d3.select(this);
        const sex = circle.datum().sexcn;
        const sport = circle.datum().sportcn;

        // Determine new cy position
        const newCy = sex === '男' 
            ? y(sport) + y.bandwidth() / 2 + 10 + (Math.random() - 0.3) * jittery
            : y(sport) + y.bandwidth() / 2 - 10 + (Math.random() - 0.5) * jittery;

        gsap.to(circle.node(), {
            attr: {
                cy: newCy
            }
        });
        gsap.to('.longevity .tick', {
            opacity: 1,
        });
        gsap.to('.medianLine', {
            opacity: 1,
        });

        gsap.to('.genderMed', {
            opacity: 0,
        });
        gsap.to('.genderMedText', {
            duration:1,
            opacity:0
        })
    });
}


            
        return () => {
            // svgGroup.selectAll('circle').remove();
            // svgGroup.selectAll('.medianLine').remove();
            // svgGroup.selectAll('*').remove();
        }
    }

    return (
        <>

        <div className='content'>
        <h2>三. 男性奥运体操冠军退役年龄更晚，其中体操男女退役年龄相差最大
        </h2>
            <div className='content__text'>
                <div className='legend' style={{ paddingBottom: '3%' }}>
                {sexcn.map((i) => (
            <div key={i} className='legend__item'>
              <div className='legend__color' style={{ borderRight: `3px solid ${colorLine(i)}`, height:'22px' }}></div>
              <div className='legend__label'>{i}退役年龄中位数</div>
              </div>
          ))}
                </div>
            </div>
        </div>

        <div ref={containerRef} className='chart-container'>
        <div className='sticky-div-wrapper'>
            <button onClick={handleToggle} className="toggle-button">
                {isToggled ? '按运动项目划分' : '按性别划分'}
            </button>
        </div>
            <svg ref={svgRef} id='gender-longevity'></svg>
            {/* <div className='y-axis' style={{ textAlign:'center' }}><b>年龄</b></div> */}
            <Tooltip content={tooltipContent} position={tooltipPosition} hovered={hovered} />
        </div>
        
        

        <div className='content'>
        <div className='scroll__caption chart-caption'>图注：将鼠标悬浮图表圆圈，可查看每个退役冠军具体信息。</div>

            <div className='content__text' style={{ paddingBottom:'5%' }}>
                <p>奥运冠军在首次夺冠后，大多会继续运动生涯一段时间。从具体项目来看，体操冠军退役年龄最早，射击奥运冠军退役年龄最晚。</p>
            </div>

            {/* <ImageScroll
            src1='./images/AP24143723469306copy.jpg'
            caption1='1984年7月29日，洛杉矶，1984年夏季奥运会50米自由手枪射击比赛冠军许海峰站在领奖台上。这是中华人民共和国中国代表团自1952年参加奥运会以来，首次在奥运中得冠。(AP / Eric Risberg)'
            src2='./images/202104anhuixuhaifeng.jpg'
            caption2='2021年4月，许海峰（左二）在安徽作报告。（安徽省马鞍山市委宣传部）' /> */}

            <div className="scroll-image">
                <div className="sticky-wrapper">
                    <div className='first-image vertical-img'>
                        <img 
                        src={path + '/images/AP24143723469306copy.jpg'} 
                        alt={'1984年7月29日，洛杉矶夏季奥运会上。50米自由手枪射击比赛冠军许海峰站在领奖台上。这是中华人民共和国中国代表团自1952年参加奥运会以来，首次得冠。(AP / Eric Risberg)'} 
                        />
                        <div className="scroll__caption">{'1984年7月29日，洛杉矶夏季奥运会上。50米自由手枪射击比赛冠军许海峰站在领奖台上。这是中华人民共和国中国代表团自1952年参加奥运会以来，首次得冠。(AP / Eric Risberg)'}</div>
                    </div>
                </div>
                <div className='second-image' >
                    <img 
                    src={path + '/images/202104anhuixuhaifeng.jpg'} 
                    alt={'2021年4月，许海峰（左二）在安徽作报告。（安徽省马鞍山市委宣传部）'}
                    />
                    <div className="scroll__caption">{'2021年4月，许海峰（左二）在安徽作报告。（安徽省马鞍山市委宣传部）'}</div>
                </div>
            </div>

            

            <div className='content__text'>
            <p>中华人民共和国自成立以來，从1952年起参加奥运会，后因<a href='https://www.cfr.org/timeline/olympics-boycott-protest-politics-history' target='_blank'>不满</a>台湾同以“中国”的身份参赛，以及国内外的一些政治原因，中国拒绝参加奥运会长达28年之久。1980年中国恢复参与奥运。直至2024年巴黎奥运会结束，中国代表团共产生了301+位奥运冠军，其中女性冠军约占67%。这与中国奥运女性运动员基数大有直接关系。有媒体认为，西方男子职业体育发展非常完善，中国想要后来者居上，迅速成为体育强国，就得集中发展女足、女垒等女性和其它小众项目，才有可获得<a href='https://m.thepaper.cn/baijiahao_13707479' target='_blank'>更多金牌</a>。</p>

            <p>但对比运动员的绝对退役年龄，歪脑发现男性平均退役年龄晚于女性。男性退役年龄中位数为29岁，女性的是27岁。在同类型男女运动员数据的项目中，体操退休年龄男女差异最大，射击和跆拳道基本持平。</p>

            </div>

            <ImageScroll
            src1='/images/AP080817023338.jpg'
            caption1='2008年8月17日星期日，中国选手郭晶晶在北京奥运会女子3米跳板跳水决赛的颁奖仪式上。(AP / Charles Dharapak)'
            src2='/images/AP21354017704241.jpg'
            caption2='2021年12月20日，亲北京的香港立法会候选人霍启刚（右四）与妻子郭晶晶，以及其他队员在立法会选举获胜后庆祝胜利。（AP / Vincent Yu）'
            />

        </div>
       
        </>
    );
    };

export default GenderLongevityV2;

